// extracted by mini-css-extract-plugin
export default {"card":"E4-z"};